import { render, staticRenderFns } from "./MainTransition.vue?vue&type=template&id=6a971b5e&scoped=true&"
import script from "./MainTransition.vue?vue&type=script&lang=js&"
export * from "./MainTransition.vue?vue&type=script&lang=js&"
import style0 from "./MainTransition.vue?vue&type=style&index=0&id=6a971b5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a971b5e",
  null
  
)

export default component.exports